import CircularProgress from '@mui/joy/CircularProgress';

export default function CircularProgressThickness() {
  return <CircularProgress thickness={1} />;
}
